import { motion } from "framer-motion";
import {
  selectBooking,
} from "../features/booking/bookingSlice";
import { GTMTrackingSelectAccommodation } from "../helpers/GTMTracking";
import { useAppSelector } from "../app/hooks";
import { useEffect, useState } from "react";
import Accommodations from "../components/Accommodation/Accommodations";
import { DateCart } from "../components/DateCart";
import { StaticCart } from "../components/StaticCart";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


function Accommodation() {
  const booking = useAppSelector(selectBooking);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [trackSelectItem, setTrackSelectItem] = useState<boolean>(false);
  useEffect(() => {
    if (trackSelectItem) {
      // Only track last item
      GTMTrackingSelectAccommodation();
      setTrackSelectItem(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [booking.Reservations]);

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: "-12px", transition: { duration: 0 } }}
        animate={{ opacity: 1, y: "0px", transition: { duration: 0.4 } }}
        exit={{ opacity: 0, y: "-12px", transition: { duration: 0 } }}
        className="absolute inset-0 overflow-y-auto w-full px-4 pb-4 pt-6"
      >
        <DateCart />
        <Accommodations />
        {booking.Rooms.length > 0 && (
          <StaticCart
            buttonText={t("cart.title.extras")}
            next={() => navigate("/summary")}
          />
        )}
      </motion.div>
    </>
  );
}

export default Accommodation;
